import angular from 'angular';

angular
  .module('cxSettings')
  .controller('EmailSignatureDialogCtrl', [
    '$element',
    'flySvc',
    'close',
    '$http',
    'ModalService',
    'appUrls',
    'companyId',
    emailSignatureDialogCtrl,
  ]);

function emailSignatureDialogCtrl(
  $element,
  flySvc,
  close,
  $http,
  ModalService,
  appUrls,
  companyId,
) {
  var vm = this;
  vm.signatures = [];
  vm.loading = true;

  $http
    .get(`${appUrls.api}/api/Template/EmailSignature/${companyId}`)
    .then(({ data }) => {
      if (data != null) {
        vm.signatures = data.map(x => ({ ...x, collapsed: !x.content }));
        if (vm.signatures.length > 0) vm.signatures[0].collapsed = false;
      }
    }, flySvc.error)
    .finally(() => {
      vm.loading = false;
    });

  vm.save = function() {
    if (vm.saving) return;
    vm.saving = true;
    $http.put(`${appUrls.api}/api/Template/EmailSignature`, vm.signatures).then(
      () => {
        vm.saving = false;
        $element.modal('hide');
        close(result, 500);
      },
      function(error) {
        vm.saving = false;
        flySvc.error(error.data.code, error.data.parameters);
      },
    );
  };

  vm.cancel = function() {
    close(null, 500);
  };

  vm.showPlaceholders = function() {
    if (!vm.placeholders) {
      $http.get(appUrls.api + '/api/Template/MailPlaceholders').then(
        function(result) {
          vm.placeholders = result.data[13];
          vm.showPlaceholders();
        },
        function(error) {
          flySvc.error(error.code, error.parameters);
        },
      );
      return;
    }

    ModalService.showModal({
      template: require('./placeholderDialog.html'),
      controller: 'PlaceholderDialogCtrl',
      controllerAs: 'vm',
      locationChangeSuccess: false,
      inputs: {
        placeholders: vm.placeholders,
        taskParameterPlaceholders: [],
        context: 13,
      },
    }).then(function(modal) {
      modal.element.modal();
      modal.element.on('hidden.bs.modal', function(e) {
        modal.element.off(e); //Remove event
        modal.element.remove(); //Remove element
      });
    });
  };
}
